export default __webpack_public_path__ + "assets/webgl/scene-25.b75342c4.glb";